var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSeries(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2DA74E43-E07C-432C-A067-2A9594C0BB5D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.1-home-aba/carreira-juridica",
    transform: "translate(-24.000000, -972.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-principal",
    transform: "translate(24.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-series",
    transform: "translate(0.000000, 740.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fillOpacity: 0,
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "replay",
    transform: "translate(2.000000, 2.000000)",
    fill: "#1717CE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7586291,3.78509181 L15.6809213,-0.664832018 L14.2652689,0.575781829 L16.892,2.877 L4.65980744,2.87789168 C1.82783417,2.87789168 -0.5,4.9178417 -0.5,7.46132364 L-0.5,10.5 L1.42920225,10.5 L1.42920225,7.46132364 L1.43464845,7.3004777 C1.5322383,5.86237652 2.92939628,4.69224514 4.65980744,4.69224514 L16.892,4.692 L14.2652689,6.994355 L15.6809195,8.23496722 L20.7586291,3.78509181 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,9.5 L18.5707955,9.5 L18.5707955,12.5386014 L18.5653491,12.6994533 C18.4677567,14.1376104 17.0705629,15.307851 15.3401812,15.307851 L3.107,15.307 L5.73468806,13.0055952 L4.31903316,11.764998 L-0.75862355,16.2150097 L4.31904057,20.6648276 L5.73470436,19.4242227 L3.107,17.122 L15.3401812,17.122194 C18.1722328,17.122194 20.5,15.0822456 20.5,12.5386014 L20.5,9.5 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSeries);
export default __webpack_public_path__ + "static/media/ic-series.739fc2c13f1d81a37e001779ac95e11a.svg";
export { ForwardRef as ReactComponent };